var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortColOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99979 11.4997C1.17281 11.4997 0.5 10.8269 0.5 9.9999V1.9998C0.5 1.17281 1.17281 0.5 1.9998 0.5H18C18.827 0.5 19.4998 1.17281 19.4998 1.9998V9.97746C19.4877 8.60936 18.371 7.5001 17.0001 7.5001C15.6217 7.5001 14.5003 8.62151 14.5003 9.9999V10.8817L13.3415 8.56483C13.0866 8.05373 12.5724 7.7359 11.9997 7.7359C11.4276 7.7359 10.9137 8.05373 10.6586 8.56537L9.27642 11.3287C9.2484 11.3848 9.22402 11.4418 9.20332 11.4996L1.99979 11.4997Z",
    fill: "#272C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99979 10.9997L8.88198 10.9996L10.2111 8.34223C10.5514 7.65982 11.2368 7.2359 11.9997 7.2359C12.7632 7.2359 13.4489 7.65982 13.7887 8.34117L14.1499 9.06346C14.5442 7.86658 15.6729 7.0001 17.0001 7.0001C17.7676 7.0001 18.4687 7.28985 18.9998 7.76566V1.9998C18.9998 1.44851 18.5513 1 18 1H1.9998C1.44851 1 1 1.44851 1 1.9998V9.9999C1 10.5512 1.44851 10.9997 1.99979 10.9997ZM15.0003 12.0007L14.3838 11.9997C14.3838 11.8454 14.3481 11.6952 14.2767 11.5524L12.8943 8.7885C12.7243 8.44764 12.3815 8.2359 11.9997 8.2359C11.6184 8.2359 11.276 8.44764 11.106 8.7885L9.7236 11.5524C9.65256 11.6945 9.61652 11.845 9.6165 11.9996L1.9998 11.9997C0.89711 11.9997 0 11.1026 0 9.9999V1.9998C0 0.89711 0.89711 0 1.9998 0H18C19.1027 0 19.9998 0.89711 19.9998 1.9998V9.9999C19.9998 10.7101 19.6167 11.3735 18.9999 11.7312V9.9999C18.9999 8.89721 18.1028 8.0001 17.0001 8.0001C15.8974 8.0001 15.0003 8.89721 15.0003 9.9999V12.0007Z",
    fill: "#272C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5V11.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.5V6.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9H10.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0909 14.8907V10.1093",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7188 11.7864L12.0907 10.1094",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4618 11.7864L12.0898 10.1094",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6733 10.6659L11.9343 10.6171L11.8339 10.5619L11.5234 10.7988",
    fill: "#272D55"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6733 10.6659L11.9343 10.6171L11.8339 10.5619L11.5234 10.7988",
    stroke: "#272D55"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1094 10.1094V14.8908",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7383 13.2129L17.1103 14.8899",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4814 13.2129L17.1094 14.8899",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6923 14.3347L16.9525 14.3842L16.8528 14.4386L16.5417 14.2024",
    fill: "#272D55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6923 14.3347L16.9525 14.3842L16.8528 14.4386L16.5417 14.2024",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortColOperationIcon);
export default __webpack_public_path__ + "static/media/SortColOperationIcon.5827d86cf6ecec48913731cc203452bb.svg";
export { ForwardRef as ReactComponent };